import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { QuickBriefNetworkId } from '../../services/quick-brief.types';
import { QuickBriefService } from '../../services/quick-brief.service';

@Component({
  selector: 'qb-network-step',
  templateUrl: './network-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex min-h-0 flex-1 flex-col overflow-hidden' },
})
export class QbNetworkStep {
  readonly brief = inject(QuickBriefService);

  tileClass(id: QuickBriefNetworkId): string {
    return this.brief.networkSelected(id)
      ? 'border-2 border-primary bg-primary/5'
      : 'border border-border bg-card hover:border-primary';
  }
}
